import { render, staticRenderFns } from "./TableOperations.vue?vue&type=template&id=b7b6028a&"
import script from "./TableOperations.vue?vue&type=script&lang=js&"
export * from "./TableOperations.vue?vue&type=script&lang=js&"
import style0 from "./TableOperations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports